import React, { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import axios from '../../services/AxiosInstance';
import { getApiUrl } from '../../utils/ApiUtils';

// Where Skatteverket sends the browser back after BankID and consent
// ("Hämta från Skatteverket" on the Skattekonto page). This URL, per
// environment, is what is registered with Skatteverket as the redirect URI.
//
// The page has one job: hand what came back (code + state, or error + state)
// to the backend, then go to the company's Skattekonto page, which shows the
// outcome. The backend verifies the state; reading the company out of it here
// only decides which company's endpoint to call.

function companyIdFromState(state) {
    try {
        const payload = state.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const { companyId } = JSON.parse(atob(payload));
        return /^[0-9a-f-]{36}$/i.test(companyId) ? companyId : null;
    } catch {
        return null;
    }
}

const SkatteverketCallback = () => {
    const location = useLocation();
    const history = useHistory();
    const started = useRef(false);

    useEffect(() => {
        // The code is single-use: a second request would be refused and its
        // error would replace the first one's success.
        if (started.current) return;
        started.current = true;

        const params = new URLSearchParams(location.search);
        const state = params.get('state') || '';
        const companyId = companyIdFromState(state);
        if (!companyId) {
            history.replace('/select-company');
            return;
        }

        const landOn = (status, reason) => {
            const query = new URLSearchParams({ skattekonto_sync: status });
            if (reason) query.set('reason', reason);
            history.replace(`/${companyId}/skattekonto?${query.toString()}`);
        };

        axios.post(
            getApiUrl(`${companyId}/accounting/reconciliation/skatteverket/sync/complete`),
            { state, code: params.get('code'), error: params.get('error') },
            { withCredentials: true }
        )
            .then(({ data }) => landOn(data?.status === 'cancelled' ? 'cancelled' : 'success'))
            .catch((err) => landOn('error', err?.response?.data?.code || 'failed'));
    }, [location.search, history]);

    return (
        <div className="vh-100 d-flex flex-column justify-content-center align-items-center" role="status">
            <div className="spinner-border text-primary" aria-hidden="true" />
            <p className="mt-3 mb-0 text-muted">Hämtar skattekontot från Skatteverket…</p>
        </div>
    );
};

export default SkatteverketCallback;
